import React from "react";

import { Avatar, Button, Flex, Typography } from "antd";

import { EXPERIMENT_FLOW_STEPS } from "../routes";

import type { ExperimentFlowStepKey } from "../types/experimentFlow.types";

interface ExperimentFlowStepperProps {
  currentStepKey: ExperimentFlowStepKey;
  onStepClick: (stepKey: ExperimentFlowStepKey) => void;
  canAccessStep: (stepKey: ExperimentFlowStepKey) => boolean;
  isStepDisabled?: (stepKey: ExperimentFlowStepKey) => boolean;
}

export const ExperimentFlowStepper: React.FC<ExperimentFlowStepperProps> = ({
  currentStepKey,
  onStepClick,
  canAccessStep,
  isStepDisabled,
}) => {
  return (
    <Flex align="center" gap={12}>
      {EXPERIMENT_FLOW_STEPS.map((step, index) => {
        const isActive = step.key === currentStepKey;
        const isEnabled = canAccessStep(step.key);
        const isDisabled = !isEnabled || Boolean(isStepDisabled?.(step.key));

        return (
          <Flex key={step.key} align="center" gap={12}>
            <Button
              type="text"
              disabled={isDisabled}
              onClick={() => onStepClick(step.key)}
              style={{
                height: "auto",
                padding: 0,
                color: isActive ? "#F4C145" : "rgba(255, 255, 255, 0.5)",
              }}
            >
              <Flex align="center" gap={8}>
                <Avatar
                  size={20}
                  style={{
                    background: isActive
                      ? "#F4C145"
                      : "rgba(255, 255, 255, 0.08)",
                    color: isActive ? "#000000" : "rgba(255, 255, 255, 0.65)",
                    fontSize: 10,
                    fontWeight: 600,
                  }}
                >
                  {step.index}
                </Avatar>
                <Typography.Text
                  style={{
                    color: isActive
                      ? "#F4C145"
                      : "rgba(255, 255, 255, 0.5)",
                    fontSize: 12,
                    fontWeight: 500,
                  }}
                >
                  {step.label}
                </Typography.Text>
              </Flex>
            </Button>
            {index < EXPERIMENT_FLOW_STEPS.length - 1 ? (
              <Typography.Text
                style={{ color: "rgba(255, 255, 255, 0.3)", fontSize: 12 }}
              >
                -
              </Typography.Text>
            ) : null}
          </Flex>
        );
      })}
    </Flex>
  );
};
